import React from 'react'

import Select from '../../packages/kiti/components/form/Select'

const ACT_OPTIONS = [
  { id: 1, name: 'Assinar' },
  { id: 2, name: 'Aprovar' },
  { id: 3, name: 'Reconhecer' },
  { id: 4, name: 'Assinar como parte' },
  { id: 5, name: 'Assinar como testemunha' },
  { id: 6, name: 'Assinar como interveniente' },
  { id: 7, name: 'Acusar recebimento' },
  { id: 8, name: 'Assinar como Emissor, Endossante e Avalista' },
  { id: 9, name: 'Assinar como Emissor, Endossante, Avalista, Fiador' },
  { id: 10, name: 'Assinar como fiador' },
  { id: 11, name: 'Assinar como parte e fiador' },
  { id: 12, name: 'Assinar como responsável solidário' },
  { id: 13, name: 'Assinar como parte e responsável solidário' }
]

const D4SignActSelect = ({ onChange, value, ...props }) => {
  return <Select value={value} onChange={onChange} options={ACT_OPTIONS} {...props} />
}

export default D4SignActSelect
